/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useEffect, useRef } from 'react';
import { useLiveAPIContext } from '../../contexts/LiveAPIContext';
import './orb.scss';

export default function Orb() {
  const { volume, connected } = useLiveAPIContext();
  const orbRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (orbRef.current) {
      // Scale the orb based on volume. Adjust the multiplier for sensitivity.
      const scale = 1 + volume * 0.5;
      orbRef.current.style.transform = `scale(${scale})`;
    }
  }, [volume]);

  return <div ref={orbRef} className={`orb ${connected ? 'active' : ''}`}></div>;
} 